import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';

export type CmsApiCtaHeroType = 'CTA_HERO';

export enum CmsApiCtaHeroBlockLayout {
  COMPACT = 'COMPACT',
  STANDARD = 'STANDARD',
}

export type CmsApiCtaHeroBlockData = {
  image: ApiFilestackImageData;
  withOverlay: boolean;
  /**
   * HTML
   */
  text: string;
  layout: CmsApiCtaHeroBlockLayout;
  buttonText: string | null;
  buttonUrl: string | null;
};

export type CmsApiCtaHeroBlock = {
  id: string;
  type: CmsApiCtaHeroType;
  data: CmsApiCtaHeroBlockData;
};
